import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import emailImg from '../assets/email.jpg';
import smsImg from '../assets/sms.jpg';
import whatsappImg from '../assets/whatsapp.png';

const services = [
  {
    name: 'Email at Scale',
    img: emailImg,
    desc: 'High-volume transactional & marketing email with advanced deliverability, templating & tracking.',
    to: '/communication',
  },
  {
    name: 'Global SMS Messaging',
    img: smsImg,
    desc: 'Instant SMS across 200+ countries with customizable sender IDs, retry logic & delivery tracking.',
    to: '/communication',
  },
  {
    name: 'WhatsApp API Integration',
    img: whatsappImg,
    desc: 'Two‑way engagement via WhatsApp Business API for notifications, OTPs & rich media messaging.',
    to: '/communication',
  },
  {
    name: 'AI Pipeline Solutions',
    img: emailImg,
    desc: 'End-to-end AI/ML pipeline design, deployment & optimization for real-world applications.',
    to: '/ai-application',
  },
  {
    name: 'Bespoke Software',
    img: smsImg,
    desc: 'Custom web, mobile & enterprise software tailored to your unique business requirements.',
    to: '/bespoke-software',
  },
  {
    name: 'Research & Security',
    img: whatsappImg,
    desc: 'Ethical hacking, zero-day vulnerability research and comprehensive security assessments.',
    to: '/research-security',
  },
];

const Features = () => (
  <section className="section">
    <h2 className="section-title">Our Capabilities</h2>
    <div className="cards">
      {services.map((s, i) => (
        <motion.div
          key={s.name}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: i * 0.1, duration: 0.5 }}
        >
          <Link to={s.to} className="card-link">
            <div className="card">
              <img src={s.img} alt={s.name} className="card-img" />
              <div className="card-body">
                <h3>{s.name}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  </section>
);

export default Features;
